<template>
  <div class="b-menu-drop-area" :style="[size]">
    <b-menu-drop-target v-for="(count, index) in maxMenuItemsPerView" :key="index" :index="index"></b-menu-drop-target>
    <b-menu-drop-target-indicator></b-menu-drop-target-indicator>
  </div>
</template>

<script>
import BMenuDropTarget from './b-menu-drop-target'
import BMenuDropTargetIndicator from './b-menu-drop-target-indicator'

import StoreHelper from '../store/helper'

export default {
  name: 'b-menu-drop-area',
  components: { BMenuDropTarget, BMenuDropTargetIndicator },
  data () {
    return {
      maxMenuItemsPerView: StoreHelper.getMaxItemsPerPage()
    }
  },
  computed: {
    size() {
      return { width: `${StoreHelper.getAppContainerSize()}px`, height: `${StoreHelper.getAppContainerSize()}px` };
    }
  },
}
</script>

<style lang="scss" scoped>
  .b-menu-drop-area {
    position: absolute;
    z-index: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    border-radius: 50%;
    overflow: hidden;
  }
</style>
